import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import API from "@/lib/api";

export default function ForgotPasswordPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [email, setEmail] = useState(params.get("email") || "");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await API.post("/auth/forgot-password", { email });
    } catch (_) {
      // Deliberately ignore — same confirmation whether the email exists.
    } finally {
      setBusy(false);
      setSent(true);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4">
      <div className="max-w-md w-full bg-white border border-slate-200 rounded-xl shadow-sm p-8" data-testid="forgot-password-page">
        <h1 className="text-xl font-bold text-slate-900" style={{ fontFamily: "Outfit, sans-serif" }}>Reset your password</h1>
        {sent ? (
          <>
            <p className="text-sm text-slate-600 mt-3" data-testid="forgot-password-confirm">
              If an account exists for that email, a password reset link is on its way. It expires in 45 minutes and can be used once. Please check your spam folder too.
            </p>
            <button onClick={() => navigate("/login")} className="mt-6 text-sm font-semibold hover:underline" style={{ color: "#100f5d" }} data-testid="forgot-back-to-login">
              Back to sign in
            </button>
          </>
        ) : (
          <form onSubmit={submit} className="mt-4 space-y-4">
            <p className="text-sm text-slate-600">Enter your email and we'll send you a secure link to set a new password.</p>
            <div>
              <label htmlFor="fp-email" className="text-sm font-medium text-slate-700">Email</label>
              <input
                id="fp-email" type="email" required value={email} maxLength={254}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-1 w-full h-11 px-3 rounded-lg border border-slate-200 focus:border-[#100f5d] focus:ring-1 focus:ring-[#100f5d] outline-none text-sm"
                data-testid="forgot-email-input" placeholder="you@example.com"
              />
            </div>
            <button type="submit" disabled={busy}
              className="w-full h-11 rounded-lg text-white font-semibold text-sm transition-colors disabled:opacity-60"
              style={{ background: "#100f5d" }} data-testid="forgot-submit-btn">
              {busy ? "Sending…" : "Email me a reset link"}
            </button>
            <button type="button" onClick={() => navigate("/login")} className="w-full text-sm text-slate-500 hover:text-slate-700" data-testid="forgot-cancel">
              Back to sign in
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
